














import TextShow from "./show/TextShow.vue";
import ImageShow from "./show/ImageShow.vue";
import VideoShow from "./show/VideoShow.vue";
import { PropType } from 'vue';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  components: {
    TextShow,
    ImageShow,
    VideoShow
  },
  props: {
    content: {
      type: Object as PropType<ContentModel>,
      required: true
    },
    trustedContent: {
      type: Boolean,
      default: false,
    }
  }
};
